// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkspaceLoader_wrapper__Kgmfi"};